// -------------------------------------------------------------------------------------------------
// Import
// -------------------------------------------------------------------------------------------------

// -------------------------------------------------------------------------------------------------
// Variables
// -------------------------------------------------------------------------------------------------

const baseClass = 'floating-contact';
let shareButtons = [];

// -------------------------------------------------------------------------------------------------
// Classes
// -------------------------------------------------------------------------------------------------

class FloatingContact {
  /**
   * @param {HTMLElement} el
   */
  constructor(el) {
    this.el = el;
    this.icon = this.el.getElementsByClassName(`${baseClass}__icon`)[0];
    this.details = this.el.getElementsByClassName(`${baseClass}__details`)[0];

    this.attachEvents();
  }

  attachEvents() {
    if (this.icon != null && this.details != null) {
      this.icon.addEventListener('click', this.handleClickEvents.bind(this));
    }
  }

  handleClickEvents(event) {
    event.preventDefault();

    this.setShareButtonVisible(this.isShareButtonVisible() === false);
  }

  isShareButtonVisible() {
    return this.details.classList.contains(`${baseClass}__details--active`);
  }

  setShareButtonVisible(visible) {
    if (this.details == null) {
      return false;
    }

    if (visible) {
      this.details.classList.add(`${baseClass}__details--active`);
    } else {
      this.details.classList.remove(`${baseClass}__details--active`);
    }

    return true;
  }
}

// -------------------------------------------------------------------------------------------------
// Methods
// -------------------------------------------------------------------------------------------------

function init() {
  shareButtons = [...document.getElementsByClassName(baseClass)]
    .map((element) => new FloatingContact(element));
}

export function setFloatingContactVisible(visible) {
  let applied = false;

  for (const shareButton of shareButtons) {
    const changed = shareButton.setShareButtonVisible(visible);

    applied = applied || changed;
  }

  return applied;
}

// -------------------------------------------------------------------------------------------------
// Export
// -------------------------------------------------------------------------------------------------

export default {
  init,
};
